import React, { useState } from "react";
import "./Form.css";
import { Container } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Swal from "sweetalert2";

let backendUrl = process.env.REACT_APP_BACKEND_API;


const Form = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const validationSchema = Yup.object({
    name: Yup.string()
                .matches(/^(?!\s*$).+/, "Name cannot be empty or only spaces") // Prevent only spaces
                .min(3, "Too short") // Minimum 3 characters
                .required("Name is required"),
    email: Yup.string()
      .matches(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "Please enter valid email"
      )
      .required("Email is required"),
    message: Yup.string().matches(/^(?!\s*$).+/, "Message cannot be empty or only spaces").min(10, "Message too short").required("Message is required"),

  });



  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      message: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      const data = {
        name: values?.name,
        email: values?.email,
        textareaValue: values?.message,
        key: "restaurant",
      };
      try {
        const submitdata = await axios.post(
          `${backendUrl}api/v1/info/saveContactInfo`,
          data,
          {
            headers: { "Content-Type": "application/json" },

          }
        );
        // alert(submitdata?.data?.message);
        // toast.success(submitdata?.data?.message);
        setResponseMessage(submitdata?.data?.message);
        setIsError(false);
        setIsModalOpen(true);
        resetForm();

        Swal.fire({
          title: "Thank you !",
          text: "Your enquiry has been successfully submitted. Our team will respond to you shortly",
          icon: "success"
        });

      } catch (error) {
        console.log("asasa", error)
        // alert(error?.response?.data?.message || error?.message);
        // toast.error(error?.response?.data?.message || error?.message);
        setResponseMessage(error?.response?.data?.message || error?.message);
        setIsError(true);
        setIsModalOpen(true);
      }
      setIsLoading(false);
    },
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const Formikerrormsg = {
    color: "red",
    fontSize: "14px",
    marginBottom: "15px",
    marginTop: "5px",
    textAlign: "start",

  };
  return (
    <Container fluid style={{ backgroundColor: "#FEF9F9" }}>
      <Container>
        <div className="main_form_wrapper" id="enquiryformprd">
          <div className="left_wrapper">
            <div className="left_upper_wrapper">
              <div className="form_first_wrapper">Hungry For <br />More</div>
              <div className="form_second_wrapper">
                <span>Information?</span>
              </div>
            </div>
            <div className="form_third_wrapper">
              Please share your details and our team will get in touch with you.
            </div>
          </div>
          <div className="form_wrapper">
            <form onSubmit={formik.handleSubmit}>
              <div className="formInput">
                <input
                  type="text"
                  placeholder="Name"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div style={Formikerrormsg}>{formik.errors.name}</div>
                ) : null}
              </div>
              <div>
                <input
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div style={Formikerrormsg}>{formik.errors.email}</div>
                ) : null}
              </div>
              <div>
                <textarea
                  name="message"
                  placeholder="Leave a message for us"
                  rows="4"
                  className="placecolor form-control"
                  style={{ resize: "none", marginBottom: "10px" }}
                  value={formik.values.message}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                ></textarea>
                {formik.touched.message && formik.errors.message ? (
                  <div style={Formikerrormsg}>{formik.errors.message}</div>
                ) : null}
              </div>
              <div className="form_submit_button_wrapper">
                {/* <button>Submit</button> */}
                <button
                  type="submit"

                  disabled={!formik.isValid || formik.isSubmitting}
                >
                  {isLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </Container>
  );
};

export default Form;
